let config = {
    development: {
        apiHost: 'http://localhost:3000',
        assetsHost: "https://virtap.s3.amazonaws.com/test",
        videosHost: "https://streaming.virtap.com.br/aulas",
        coursesHost: "https://streaming.virtap.com.br/cursos",
        introAVCompletePage: "http://localhost:8000/curso-gratuito-concluido",
        virtapClubPage: "http://localhost:8000/virtap-club.html",
        loginPage: "http://localhost:8000/login.html",
        formAPPage: "http://localhost:8000/formacoes/assistencia-pessoal/",
        signupPage: "http://localhost:8000/cadastrar.html",
        profilePage: "http://localhost:8000/perfil.html",
        subscribePage: "http://localhost:8000/assinar.html",
        purchaseCoursePage: "http://localhost:8000/comprar.html"

    },
    production: {
        apiHost: 'https://apinew.virtap.com.br',
        assetsHost: "https://virtap.s3.amazonaws.com/production",
        videosHost: "https://streaming.virtap.com.br/aulas",
        coursesHost: "https://streaming.virtap.com.br/cursos",
        introAVCompletePage: "https://new.virtap.com.br/curso-gratuito-concluido",
        virtapClubPage: "https://new.virtap.com.br/virtap-club",
        loginPage: "https://new.virtap.com.br/login",
        formAPPage: "https://new.virtap.com.br/formacoes/assistencia-pessoal/",
        signupPage: "https://new.virtap.com.br/cadastrar",
        profilePage: "https://new.virtap.com.br/perfil",
        subscribePage: "https://new.virtap.com.br/assinar",
        purchaseCoursePage: "https://new.virtap.com.br/comprar"
    }
}

export default config[process.env.NODE_ENV];
